/**
 * Language Configuration
 * Central source of truth for supported languages across the application
 * Note: flags are 2-letter country codes, not emoji, to comply with
 * the project's "no emojis in UI" rule.
 */

import { SupportedLanguage } from '@umituz/web-design-system/hooks';

export const SUPPORTED_LANGUAGES: Record<string, SupportedLanguage> = {
  'en-US': { name: 'English', flag: 'EN' },
  'tr-TR': { name: 'Türkçe', flag: 'TR' },
  'de-DE': { name: 'Deutsch', flag: 'DE' },
  'es-ES': { name: 'Español', flag: 'ES' },
  'ru-RU': { name: 'Русский', flag: 'RU' },
};

export const DEFAULT_LANGUAGE = 'en-US';
export const FALLBACK_LANGUAGE = 'en-US';
